<template>
  <div
    v-if="activeCrumb"
    class="breadcrumbs-container"
  >
    <div
      class="crumbs"
    >
      <span
        v-for="(crumb, index) in parentCrumbs"
        :key="index"
        class="tester"
      >
        <span class="pre-crumb">
          {{ crumb.name }}
        </span>
        <span class="divider">
          <SvgIcon :data="require('@icons/streamline-icons/Outline version/52-Arrows-Diagrams/01-Arrows/arrow-right-1.svg')" />
        </span>
      </span>
      <span class="active-crumb">
        {{ activeCrumb }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GetterTypes from '@/store/constants/getters';

export default {
  name: 'Breadcrumbs',
  computed: {
    ...mapGetters([
      GetterTypes.BREADCRUMBS,
    ]),
    parentCrumbs() {
      return this.breadcrumbs.slice(0, -1);
    },
    activeCrumb() {
      return this.breadcrumbs[this.breadcrumbs.length - 1]?.name;
    },
  },

};
</script>

<style lang="scss" scoped>
  .breadcrumbs-container {
    display: grid;
    align-items: center;
    height: 25px;
    position: relative;
    font-weight: 500;
    font-size: 10px;
    border-bottom: 1px solid var(--primary-divider-hex);
    color: var(--accent-text-color-hex);
    padding: 2px 0;

    .crumbs {
      transition: transform 0.4s, opacity 0.4s;

      .tester {
        display: inline-grid;
        grid-template-columns: 1fr auto;
        align-items: center;
      }

      .pre-crumb {
        font-weight: 400;
      }

      .active-crumb {
        font-weight: 700;
      }
    }

    .divider {
      font-size: 0.8em;
      padding: 0 8px;
    }
  }
</style>
